import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import {
  AuthenticationContextService,
  JwtAuthenticationService,
  JwtAuthenticationStore,
  JwtHelper,
  SOFTLINE_FEATURE_JWT_AUTHENTICATION,
} from '@softline/auth';
import { isDefinedNotEmpty, isNullOrEmpty, Store } from '@softline/core';
import { EmbeddedShellService } from '../embedded-shell/embedded-shell.service';

export const embeddedAuthGuard: CanActivateFn = async (
  route,
  state
): Promise<boolean> => {
  console.log('---- [embeddedAuthGuard] init: ', route, state.url);

  const embeddedShellService = inject(EmbeddedShellService);
  embeddedShellService.rootUrl.set(state.url);

  const store = inject(Store);
  const authService = inject(JwtAuthenticationService);
  const authContextService = inject(AuthenticationContextService);
  const tokenQueryParam = route.queryParamMap.get('token');

  if (isNullOrEmpty(tokenQueryParam)) {
    const existingToken = await authService.load();

    console.log(
      '---- [embeddedAuthGuard] token',
      existingToken,
      !!isDefinedNotEmpty(existingToken)
    );

    if (isDefinedNotEmpty(existingToken)) return !!isDefinedNotEmpty(existingToken);

    const existingTokenFromWindow = (window as any)?.softlineAuthToken;

    if (isDefinedNotEmpty(existingTokenFromWindow)) {
      await authService.save(existingTokenFromWindow, true);

      // As of now, this is required since JwtAuthenticationInterceptor is subscribed to the store
      // If we do not set this, the token will not be set in the interceptor which leads to 401
      store.commit(
        SOFTLINE_FEATURE_JWT_AUTHENTICATION,
        JwtAuthenticationStore.mutations.setToken,
        existingTokenFromWindow
      );

      authContextService.set(existingTokenFromWindow);
    }

    console.log(
      '---- [embeddedAuthGuard] token from window',
      existingTokenFromWindow,
      !!isDefinedNotEmpty(existingTokenFromWindow)
    );

    return !!isDefinedNotEmpty(existingTokenFromWindow);
  }

  const token = decodeURIComponent(tokenQueryParam);
  const date = JwtHelper.getExpirationDate(token);

  if (!date) return false;

  const expirationDate = new Date(date);
  const expired = expirationDate < new Date();

  if (expired) return false;

  await authService.save(token, true);

  // As of now, this is required since JwtAuthenticationInterceptor is subscribed to the store
  // If we do not set this, the token will not be set in the interceptor which leads to 401
  store.commit(
    SOFTLINE_FEATURE_JWT_AUTHENTICATION,
    JwtAuthenticationStore.mutations.setToken,
    token
  );

  authContextService.set(token);

  return true;
};
